/**
 * Team store — roster management (names, numbers, sizes) for team orders.
 */
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export interface TeamMember {
  id: string;
  name: string;
  number: string;
  size: string;
}

export const useTeamStore = defineStore('team', () => {
  const members = ref<TeamMember[]>([]);
  const isTeamMode = ref(false);

  const memberCount = computed(() => members.value.length);

  function addMember(member?: Partial<TeamMember>) {
    const id = `team-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    members.value.push({
      id,
      name: member?.name ?? '',
      number: member?.number ?? '',
      size: member?.size ?? '',
    });
  }

  function removeMember(id: string) {
    members.value = members.value.filter((m) => m.id !== id);
  }

  function updateMember(id: string, patch: Partial<TeamMember>) {
    const member = members.value.find((m) => m.id === id);
    if (member) Object.assign(member, patch);
  }

  function clearAll() {
    members.value = [];
  }

  function enableTeamMode() {
    isTeamMode.value = true;
  }

  function disableTeamMode() {
    isTeamMode.value = false;
    clearAll();
  }

  return {
    members,
    isTeamMode,
    memberCount,
    addMember,
    removeMember,
    updateMember,
    clearAll,
    enableTeamMode,
    disableTeamMode,
  };
});
